import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let currentUser = null;
    const token = localStorage.getItem('user');
    const updatePassToken = JSON.parse(localStorage.getItem('updatepasstoken')!);
    const verifyToken = JSON.parse(localStorage.getItem('verifytoken')!);

    if (verifyToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${verifyToken.token}`
        }
      });
    }

    if (updatePassToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${updatePassToken.token}`
        }
      });
    }

    if (token) {
      currentUser = JSON.parse(token);
    }

    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
    }

    return next.handle(request); 
  }
}
